import "../styles/heading.css";

const Heading = () => {
  return (
    <header>
        <h1 className="password-generator-heading">PASSWORD GENERATOR</h1>
    </header>
  )
}

export default Heading